import React from 'react'

import { PageLayout } from '../../components'
import { FilterGroup } from '../../components/FilterGroup'
import { PaginatedListingsGrid } from '../../components/PaginatedListingsGrid'
import { TenantPreferenceContextProvider, useAuthenticationContext } from '../../hooks'
import { useTranslation } from '../../i18n'

const ListRecommendedListingsScreen: React.FC = () => {
  const { t } = useTranslation('main-tenantPreference')
  const { user } = useAuthenticationContext()

  return (
    <TenantPreferenceContextProvider userId={user.id} isAdmin={false} columnNumber={2}>
      <PageLayout title={t('title')} subtitle={t('description')}>
        <FilterGroup />
        <PaginatedListingsGrid />
      </PageLayout>
    </TenantPreferenceContextProvider>
  )
}

export { ListRecommendedListingsScreen }
